/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Purchase_ScopeInputs */

const en_reference_field_purchase_scope = /** @type {(inputs: Reference_Field_Purchase_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code of the purchases from`)
};

/**
* | output |
* | --- |
* | "Code of the purchases from" |
*
* @param {Reference_Field_Purchase_ScopeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_purchase_scope = /** @type {((inputs?: Reference_Field_Purchase_ScopeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Purchase_ScopeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_purchase_scope(inputs)
});